import { PhysicalAddressOfPartnerInterface } from "@/api/Users/GetCurrentUser/Interfaces/PhysicalAddressOfPartnerInterface";
import { notSelectedId, notSelectedString } from "@/config/Other";
import { RootState } from "@/store/Store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const noRequiredPhoneValue = "no_required_phone";

export interface CallCourierInOpenOrderDataInterface {
    callCourierModalOpen: boolean,
    form: {
        address: {
            id: PhysicalAddressOfPartnerInterface["id"],
        },
        phone: string,
        phoneAdditional: string,
        date: string,
        dateError: string,
        time: string,
    }
}

function getInitialState() {
    const state: CallCourierInOpenOrderDataInterface = {
        callCourierModalOpen: false,
        form: {
            address: {
                id: notSelectedId,
            },
            phone: notSelectedString,
            phoneAdditional: "",
            date: "",
            dateError: "",
            time: "8-11",
        }
    };
    return state;
}

export const CallCourierInOpenOrderSlice = createSlice({
    name: "CallCourierInOpenOrderSlice",
    initialState: getInitialState(),
    reducers: {
        changeModalOpen: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<boolean>) => {
            state.callCourierModalOpen = action.payload;
        },
        setFormAddressId: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<CallCourierInOpenOrderDataInterface["form"]["address"]["id"]>) => {
            state.form.address.id = action.payload;
        },
        setFormPhone: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<CallCourierInOpenOrderDataInterface["form"]["phone"]>) => {
            state.form.phone = action.payload;
        },
        setFormAdditionalPhone: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<CallCourierInOpenOrderDataInterface["form"]["phoneAdditional"]>) => {
            state.form.phoneAdditional = action.payload;
        },
        setFormDate: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<CallCourierInOpenOrderDataInterface["form"]["date"]>) => {
            state.form.date = action.payload;
        },
        setFormDateError: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<CallCourierInOpenOrderDataInterface["form"]["dateError"]>) => {
            state.form.dateError = action.payload;
        },
        setFormTime: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<CallCourierInOpenOrderDataInterface["form"]["time"]>) => {
            state.form.time = action.payload;
        },
        resetForm: (state: CallCourierInOpenOrderDataInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.form.address = initialState.form.address;
            state.form.phone = initialState.form.phone;
            state.form.phoneAdditional = initialState.form.phoneAdditional;
            state.form.date = initialState.form.date;
            state.form.time = initialState.form.time;
        },
    },
});

export const {
    changeModalOpen,
    setFormAddressId,
    setFormPhone,
    setFormAdditionalPhone,
    setFormDate,
    setFormDateError,
    setFormTime,
    resetForm,
} = CallCourierInOpenOrderSlice.actions;

export const callCourierModalOpenSelector = (state: RootState) => state.callCourierInOpenOrder.callCourierModalOpen;
export const callCourierFormSelector = (state: RootState) => state.callCourierInOpenOrder.form;

export const CallCourierInOpenOrderReducer = CallCourierInOpenOrderSlice.reducer;
